import { translate } from '@thoughtspot/i18n';
import _ from 'lodash';
import { DateFilterType } from '/@services/generated/graphql-types';
import { DateFilterProto } from '../date-filter';
import { updateDefaultFixedFilterValues } from './fixed-date-filter/fixed-date-filter-operands.util';
import { updateDefaultRollingFilterValues } from './rolling-date-filter/rolling-date-filter-operands.util';

export enum DateFilterTabTypes {
    Rolling = 'ROLLING',
    Fixed = 'FIXED',
    Custom = 'CUSTOM',
}

export const DateFilterTabTypesArray = [
    DateFilterTabTypes.Rolling,
    DateFilterTabTypes.Fixed,
];

export const getDateFilterTabToTitle = () => {
    return {
        [DateFilterTabTypes.Rolling]: translate(
            'dateFilter.dateFilterType.rolling',
        ),
        [DateFilterTabTypes.Fixed]: translate(
            'dateFilter.dateFilterType.fixed',
        ),
        [DateFilterTabTypes.Custom]: translate(
            'dateFilter.dateFilterType.custom',
        ),
    };
};

export const DATE_FILTER_TAB_TO_IDX = {
    [DateFilterTabTypes.Rolling]: 0,
    [DateFilterTabTypes.Fixed]: 1,
    [DateFilterTabTypes.Custom]: 2,
};

export const DATE_FILTER_TAB_INITIAL_STATE = DateFilterTabTypes.Fixed;

export const FIXED_DATE_FILTER_TYPE_POSSIBLE_VALUES = [
    DateFilterType.ExactDate,
    DateFilterType.ExactDateRange,
    DateFilterType.MonthYear,
    DateFilterType.QuarterYear,
    DateFilterType.YearOnly,
];

export const getTabFromDateFilterProto = (
    dateFilterType?: DateFilterType,
): DateFilterTabTypes => {
    if (_.isNil(dateFilterType)) {
        return DATE_FILTER_TAB_INITIAL_STATE;
    }
    if (FIXED_DATE_FILTER_TYPE_POSSIBLE_VALUES.includes(dateFilterType)) {
        return DateFilterTabTypes.Fixed;
    }
    return DateFilterTabTypes.Rolling;
};

export const getInitValuesForFixed = (
    selectedFilter: DateFilterProto,
): DateFilterProto => {
    const tab = getTabFromDateFilterProto(selectedFilter?.dateFilterType);
    if (
        _.isEqual(DateFilterTabTypes.Fixed, tab) &&
        !_.isNil(selectedFilter?.dateFilterType)
    ) {
        return selectedFilter;
    }
    return updateDefaultFixedFilterValues(selectedFilter);
};
export const getInitValuesForRolling = (
    selectedFilter: DateFilterProto,
): DateFilterProto => {
    const tab = getTabFromDateFilterProto(selectedFilter?.dateFilterType);
    if (
        _.isEqual(DateFilterTabTypes.Rolling, tab) &&
        !_.isNil(selectedFilter?.dateFilterType)
    ) {
        return selectedFilter;
    }
    return updateDefaultRollingFilterValues();
};
